var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checking)?_c('p',{attrs:{"role":"status"}},[_vm._v("กำลังตรวจสอบสิทธิ์ผู้ดูแลระบบ…")]):(!_vm.allowed)?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.message))]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }